import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveWorkoutTypes } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import MultiSelect from '../../../components/multi-select';

const selectOptions = [
  {
    optionText: 'Walking',
    optionValue: 'walk'
  },
  {
    optionText: 'Hiking',
    optionValue: 'hiking'
  },
  {
    optionText: 'Walk-run intervals',
    optionValue: 'walkrunintervals'
  },
  {
    optionText: 'Moderate-pace running (4–6.5 mph)',
    optionValue: 'moderatepacerunning'
  },
  {
    optionText: 'Run intervals',
    optionValue: 'runintervals'
  },
  {
    optionText: 'Fast-pace running (7+ mph)',
    optionValue: 'fastpacerunning'
  }
];

export class PureWorkoutType extends Component {
  constructor(props) {
    super(props);

    this.state = { workoutTypes: props.initialValue };
  }

  save = async () => {
    try {
      await this.props.saveWorkoutTypes(this.state.workoutTypes);
    } catch (e) {
      /* do nothing */
    }
  }

  getActiveOptions = () => {
    const findIndex = (workoutType) => {
      return selectOptions.findIndex(({ optionValue }) => optionValue === workoutType);
    };
    return this.state.workoutTypes.map(findIndex);
  }

  setWorkoutTypes = (activeOptions) => {
    const workoutTypes = activeOptions.map(
      index => selectOptions[index].optionValue
    );
    this.setState({ workoutTypes });
  }

  render() {
    return (
      <SettingsContainer
        save={ this.save }
        className="workout-type-page"
        pageTitle="What workout types do you prefer?"
        hideSkip={ this.props.appName === 'wolf' }
        subtitle
        isValid={ Boolean(this.state.workoutTypes.length) }
      >
        <MultiSelect
          selectOptions={ selectOptions }
          initialValue={ this.getActiveOptions() }
          setActiveOptions={ this.setWorkoutTypes }
        />
      </SettingsContainer>
    );
  }
}

PureWorkoutType.propTypes = {
  initialValue: PropTypes.array.isRequired,
  saveWorkoutTypes: PropTypes.func.isRequired,
  appName: PropTypes.string,
};

PureWorkoutType.defaultProps = {
  initialValue: []
};

export default connect(
  state => ({
    initialValue: state.user.workout_types,
    appName: state.config.appName,
  }),
  dispatch => ({
    saveWorkoutTypes: workoutTypes => dispatch(saveWorkoutTypes(workoutTypes))
  }),
  null,
  { withRef: true }
)(PureWorkoutType);
